import React, { useState } from "react";

import Notes from "../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import FormAction from "../../../../../components/common/FormAction";
import RightBar from "../../../../../components/common/RightBar";

import {
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Row,
  Select,
} from "antd";

import { RiAddCircleFill, RiCloseCircleFill } from "react-icons/ri";

import "./ManageEstimates.css";
import { useParams } from "react-router";
import { Approvals, vendors } from "./data";

const ManageEstimatesRightBar = [];

function ManageEstimates() {
  const [estimates, setEstimates] = useState([
    {
      estimateReqOn: "",
      vendor: "",
      estimateRecOn: "",
      estimateAmount: "",
      estimateApproval: "",
    },
  ]);

  const { workOrderNumber } = useParams();

  const addAnotherEstimates = () => {
    setEstimates([
      ...estimates,
      {
        estimateReqOn: "",
        vendor: "",
        estimateRecOn: "",
        estimateAmount: "",
        estimateApproval: "",
      },
    ]);
  };

  const onRemoveEstimates = (index) => {
    const newEstimates = [...estimates];
    newEstimates.splice(index, 1);
    setEstimates(newEstimates);
  };
  return (
    <>
      <div className="manage-estimates">
        <Card title={`Estimates for Work Order # ${workOrderNumber}`}>
          <Form layout="vertical">
            <Row gutter={[0, 24]}>
              {estimates.map((item, index) => {
                return (
                  <Col span={24}>
                    <Row gutter={[16, 0]} align="middle">
                      <Col span={23}>
                        <Row gutter={[0, 16]}>
                          <Col span={24}>
                            <Row gutter={[8, 0]}>
                              <Col span={8}>
                                <Form.Item
                                  label="Estimate Requested On"
                                  required
                                >
                                  <DatePicker style={{ width: "100%" }} />
                                </Form.Item>
                              </Col>
                              <Col span={16}>
                                <Form.Item label="Vendor">
                                  <Select style={{ width: "100%" }} options={vendors} showSearch allowClear/>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Row gutter={[8, 0]}>
                              <Col span={8}>
                                <Form.Item label="Estimate Received On">
                                  <DatePicker style={{ width: "100%" }} />
                                </Form.Item>
                              </Col>
                              <Col span={8}>
                                <Form.Item label="Estimate Amount">
                                  <InputNumber style={{ width: "100%" }} />
                                </Form.Item>
                              </Col>
                              <Col span={8}>
                                <Form.Item label="Estimate Approval">
                                  <Select style={{ width: "100%" }} options={Approvals}/>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Notes />
                          </Col>
                          <Col span={24}>
                            <AttachmentsUpload />
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        span={1}
                        className="btn-delete-icon"
                        onClick={() => onRemoveEstimates(index)}
                      >
                        <RiCloseCircleFill size={18} />
                      </Col>
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  className="add-icon-btn"
                  onClick={() => addAnotherEstimates()}
                >
                  <RiAddCircleFill size={18} />
                  <span>Add Another Estimate</span>
                </button>
              </Col>
              <Col span={24}>
                <Form.Item label="Withhold Owner Funds">
                  <Checkbox>
                    Withhold $0.00 from the owner for this work order.
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={24}>
                <FormAction />
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ManageEstimatesRightBar} />
      </div>
    </>
  );
}

export default ManageEstimates;
